import React, { useState } from 'react';
import { caseStudies } from '../mock';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { ExternalLink } from 'lucide-react';
import './CaseStudies.css';

const CaseStudies = () => {
  const [selectedCase, setSelectedCase] = useState(null);

  return (
    <section id="case-studies" className="case-studies-section">
      <div className="case-studies-container">
        <div className="case-studies-header">
          <span className="section-label">Case Studies</span>
          <h2 className="section-title">Proven Results Across Sectors</h2>
          <p className="section-description">
            Strategic interventions that delivered measurable impact for clients
          </p>
        </div>

        <div className="case-studies-grid">
          {caseStudies.map((study) => (
            <Card key={study.id} className="case-study-card">
              <div className="case-study-image-wrapper">
                <img
                  src={study.image}
                  alt={study.title}
                  className="case-study-image"
                />
                <div className="case-study-overlay">
                  <span className="case-study-sector">{study.sector}</span>
                  <span className="case-study-region">{study.region}</span>
                </div>
              </div>
              <div className="case-study-content">
                <div className="case-study-meta">
                  <span className="case-study-year">{study.year}</span>
                </div>
                <h3 className="case-study-title">{study.title}</h3>
                <p className="case-study-excerpt">{study.challenge.substring(0, 120)}...</p>
                <Button
                  onClick={() => setSelectedCase(study)}
                  className="case-study-button"
                >
                  Read Case Study <ExternalLink size={16} />
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </div>

      {/* Case Study Detail Dialog */}
      <Dialog open={!!selectedCase} onOpenChange={() => setSelectedCase(null)}>
        <DialogContent className="case-study-dialog">
          {selectedCase && (
            <>
              <DialogHeader>
                <DialogTitle className="dialog-title">{selectedCase.title}</DialogTitle>
                <div className="dialog-meta">
                  <span>{selectedCase.sector}</span> • <span>{selectedCase.region}</span> • <span>{selectedCase.year}</span>
                </div>
              </DialogHeader>
              <div className="dialog-body">
                <img src={selectedCase.image} alt={selectedCase.title} className="dialog-image" />
                <div className="dialog-section">
                  <h4>Challenge</h4>
                  <p>{selectedCase.challenge}</p>
                </div>
                <div className="dialog-section">
                  <h4>Approach</h4>
                  <p>{selectedCase.approach}</p>
                </div>
                <div className="dialog-section">
                  <h4>Outcome</h4>
                  <p>{selectedCase.outcome}</p>
                </div>
                <div className="dialog-impact">
                  <strong>Impact:</strong> {selectedCase.impact}
                </div>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default CaseStudies;
